module.exports = __webpack_public_path__ + "img/logo.30d23eee.svg";